import { Button } from "@chakra-ui/react"
import { useNavigate } from "@tanstack/react-router"

const CatalogButton: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Button
      onClick={() => {
        navigate({ to: "/catalog" })
      }}
    >
      Continue Shopping{" "}
    </Button>
  )
}

export default CatalogButton
